import { render, staticRenderFns } from "./score-table.vue?vue&type=template&id=418345fc&scoped=true&"
import script from "./score-table.vue?vue&type=script&lang=js&"
export * from "./score-table.vue?vue&type=script&lang=js&"
import style0 from "./score-table.vue?vue&type=style&index=0&id=418345fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418345fc",
  null
  
)

export default component.exports